module.exports = {"title":"Pronto! VeloeTag nova a caminho. :)","paragraph":"Nós vamos mandar uma VeloeTag novinha em folha para você. Em até 7 dias úteis, você receberá o Veloe no endereço selecionado. A entrega só pode ser recebida por uma pessoa com mais de 18 anos, com documento atualizado e com foto.","titleProtocol":"Enquanto isso, anote o número do protocolo:","submitButton":"Continuar"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/NewIdentifierSuccess/data.json
// module id = 1789
// module chunks = 0